import {
  SET_JOURNAL_DATA,
  SET_JOURNAL_LOADING,
  SET_JOURNAL_FILTERS,
  NETWORK_REQUEST_SENT,
} from './types';
import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import { checkAndUpdateToken } from './auth';
import { createNotification } from '../components/notifications/notifications';

export const setFilters = (payload) => ({ type: SET_JOURNAL_FILTERS, payload });
export const setData = (payload) => ({ type: SET_JOURNAL_DATA, payload });

/* ---------- Фильтры ---------- */

// Учебные годы. GET /journal/v2/years
export const getYears = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/v2/years`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SET_JOURNAL_FILTERS, payload: { years: result.years } });
      return result.years;
    }
  }
};

// Учебные периоды выбранного года. GET /journal/v2/terms?year_id=
export const getTerms = (yearId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/v2/terms?year_id=${yearId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SET_JOURNAL_FILTERS, payload: { terms: result.terms } });
      return result.terms;
    }
  }
};

// Группы выбранного периода. GET /journal/v2/groups?term_id=
export const getGroups = (termId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/v2/groups?term_id=${termId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SET_JOURNAL_FILTERS, payload: { groups: result.groups } });
      return result.groups;
    }
  }
};

// Дисциплины группы за период. GET /journal/v2/disciplines?term_id=&gid=
export const getDisciplines = (termId, gid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/v2/disciplines?term_id=${termId}&gid=${gid}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SET_JOURNAL_FILTERS, payload: { disciplines: result.disciplines } });
      return result.disciplines;
    }
  }
};

/* ---------- Сетка журнала ---------- */

// Данные сетки журнала. GET /journal/v2/grid?term_id=&gid=&cid=
export const getData = (termId, gid, cid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_JOURNAL_LOADING, payload: true });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/v2/grid?term_id=${termId}&gid=${gid}&cid=${cid}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SET_JOURNAL_DATA, payload: result });
    }

    dispatch({ type: SET_JOURNAL_LOADING, payload: false });
  }
};

/* ---------- Сохранение оценки / факта ---------- */

// Сохранить/обновить/удалить оценку. POST /journal/v2/grade
// body: { sheid, week_id, student_mid, grade, grade_type, activity, comment, teacher_mid }
// Возвращает { student_avg, lesson_total, success } для точечного обновления итогов.
export const saveGrade = (body) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/journal/v2/grade`, {
      ...buildDefaultHeaders(getState),
      method: 'post',
      body: JSON.stringify(body),
    });

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      return response.json();
    }

    // createNotification(
    //   'error',
    //   'Журнал',
    //   response.status === 403
    //     ? 'Нет прав на редактирование оценки'
    //     : 'Не удалось сохранить оценку'
    // );
  }
};

// Признак «Занятие проведено». POST /journal/v2/lesson_fact
// body: { sheid, week_id, is_fact }
// Возвращает { is_fact, success }.
export const saveLessonFact = (body) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/journal/v2/lesson_fact`, {
      ...buildDefaultHeaders(getState),
      method: 'post',
      body: JSON.stringify(body),
    });

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      return response.json();
    }

    response.status !== 403 && createNotification('error', 'Журнал', 'Не удалось изменить факт проведения занятия');
  }
};
